import React, { useEffect, useState } from 'react';
import './LeadCaptureForm.css'; 

const LeadCaptureForm = ({ section, isRightAligned }) => {
  const RD_FORM_ID = 'site-43fb46568641c2e7c1db';
  
  // Estado para controlar a exibição do loader de forma elegante
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = "https://d335luupugsy2.cloudfront.net/js/rdstation-forms/stable/rdstation-forms.min.js";
    script.type = 'text/javascript';
    script.async = true;
    document.body.appendChild(script);

    let observer;
    const targetElement = document.getElementById(RD_FORM_ID);
    
    if (targetElement) {
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (window.RDStationForms) {
              try {
                new window.RDStationForms(RD_FORM_ID, 'null').createForm();
                
                // Força o loader a sumir logo após a inicialização do iframe
                setTimeout(() => setIsLoaded(true), 600);
                
                observer.unobserve(targetElement);
              } catch (err) {
                console.error("Erro ao inicializar o RDStation:", err);
              }
            }
          }
        });
      }, { rootMargin: "200px" });

      observer.observe(targetElement);
    }

    return () => {
      if (observer && targetElement) observer.unobserve(targetElement);
      if (document.body.contains(script)) document.body.removeChild(script);
    };
  }, []);

  // Variáveis dinâmicas de alinhamento mantidas originais
  const alignClass = isRightAligned ? "section-header-right mb-5 pb-4" : "mb-5 pb-4";
  const revealDirection = isRightAligned ? "reveal-from-left" : "reveal-from-right";
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const opacityValue = (section.background_opacity || 100) / 100;

  const dynamicStyle = { position: 'relative', overflow: 'hidden' };
  if (section.background_type === 'color' || (!section.background_image_url && section.background_color)) {
    dynamicStyle.backgroundColor = section.background_color;
  }

  return (
    <section id={section.slug} className={`py-5 ${(!section.background_color && !section.background_image_url) ? 'default-section' : ''}`} style={dynamicStyle}>
      {section.background_type === 'image' && section.background_image_url && (
        <div className="bg-parallax" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundImage: `url(${backendUrl}${section.background_image_url})`, backgroundSize: 'cover', backgroundPosition: 'center', zIndex: 0 }}></div>
      )}

      {section.background_type === 'image' && section.background_image_url && (
        <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(255, 255, 255, 0.99)', opacity: opacityValue, zIndex: 1 }}></div>
      )}

      <div className="container py-5" style={{ position: 'relative', zIndex: 2 }}>
        <div className={alignClass}>
          <h2 className={`fonte-primaria display-4 section-title reveal-element ${revealDirection} duration-10`}>{section.title}</h2>
          <h4 className={`fonte-terciaria section-subtitle mb-4 reveal-element ${revealDirection} duration-12`}>{section.subtitle}</h4>
          {section.content && <p className={`fonte-terciaria lead text-dark reveal-element ${revealDirection} duration-14`}>{section.content}</p>}
        </div>
       
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="card shadow-sm border-0 rounded-4" style={{ minHeight: '300px' }}>
              <div className="fonte-terciaria card-body p-4 p-md-5 text-center">
                
                {/* Exibe o loader apenas enquanto isLoaded for false */}
                {!isLoaded && (
                  <div className="text-muted py-5">
                    <div className="spinner-border text-primary mb-2" role="status"></div>
                    <p>Carregando formulário de atendimento...</p>
                  </div>
                )}

                {/* DIV Alvo do RD Station */}
                <div role="main" id={RD_FORM_ID}></div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LeadCaptureForm;